<template>
  <b-button
    variant="danger"
    @click="remove"
  >
  <b-icon
    icon="person-dash-fill"
  />
    削除
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/edit'
    }
  },

  methods: {
    remove () {
      this.$store.dispatch('modal/setRemove', async () => {
        this.$store.dispatch('loading/show')
        const result = await this.$store.dispatch(`${this.modelName}/remove`)
        this.$store.dispatch('loading/hide')

        if (result) {
          this.$store.dispatch('toast/show', {
            content: 'メンバーを削除しました。',
            title: 'メンバーの削除'
          })
          this.$router.back(-1)
        }
      })
    }
  }
}
</script>
